export default {"src":"/_next/static/media/breadcrumb-home.7bfd4dc2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};